import { getJSONfromDOM } from '@pixelcabin/ui-utils';

/**
 * Uses the API of vue-custom-element to preprocess the props which are passed
 * as string values but which need to be initialised JS objects before the component mounts.
 *
 * See https://github.com/karol-f/vue-custom-element#options
 */
export const tabThumbnailSwitcherPreprocess = {
  beforeCreateVueInstance(RootComponentDefinition) {
    try {
      const instanceId =
        RootComponentDefinition.el.parentElement.dataset.instanceId;
      const jsonData = getJSONfromDOM([`#product-info-${instanceId}`]);
      const { propsData } = RootComponentDefinition;

      RootComponentDefinition.propsData = {
        ...propsData,
        ...jsonData
      };
    } catch (err) {
      console.warn(err);
    }

    return RootComponentDefinition;
  }
};
